// extracted by mini-css-extract-plugin
module.exports = {"content":"CompressionDeliveryContent_content__IWuk8"};